import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import styled from 'styled-components'
import Moment from 'moment';
import GenericModal from '../../GenericModal'
import ThunderIcon from '../../../images/thunder.svg'
import InfoIcon from '../../../images/info.svg'
import EmployeeService from '../../../services/Employee.service'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions as employeeActions } from '../../../actions/employee'
import { actions as maintenanceActions } from '../../../actions/maintenance'

import { history } from '../../../store'

const VestedAwardDetails = styled(GenericModal) `
  .generic-modal-content, .generic-modal-footer {
    padding: 0;
  }
`

const Content = styled.div`

  h3 {
    font-family: Lato-Regular;
    font-size: 12px;
    font-weight: normal;

    color: #666666;
    line-height: 16px;
    margin: 0px;
    padding: 0px;
  }

  .value {
    font-family: Lato-Regular;
    font-size: 14px;
    color: #2B2B2B;
    line-height: 22px;
  }

  .logo {
    font-family: Lato-Regular;
    font-size: 13px;
    color: #2B2B2B;
    line-height: 22px;
  }

  .award-name {
    display: block;
    font-family: Lato-Regular;
    font-size: 14px;
    color: #2B2B2B;
    line-height: 22px;
    margin-top: 3px;
  }

  .award-date {
    display: block;
    font-family: Lato-Regular;
    font-size: 12px;
    color: #666666;
    line-height: 16px;
  }

  .federal-tax {
    background: #303042;
    border-radius: 100px;
    //float: right;
    padding: 4px 10px 5px 10px;
    font-family: Lato-Regular;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 16px;
    //margin-top: 2px;
    margin-left: auto;
  }

  > div.award-info-section, > div.vest-details-section {
    // Desktop version.
    @media (min-width: 768px) {
      padding: 15px 20px 10px 20px;
    }

    // Mobile version.
    @media (max-width: 768px) {
      padding: 15px 15px 10px 15px;
    }
  }

  > div.award-info-section {
    background-color: #F2F2F2;
    padding: 16px 20px 17px 20px;

    // Award Info
    > div:first-child {
      > h3 {
        margin-bottom: 6px;
      }
    }
  }

  > div.vest-details-section {
    border-bottom: 1px solid #DDDDDD;
  }

  // Transaction Summary
  > div.vest-details-section, > div.tax-details-section {
    padding: 16px 20px 10px 20px;

    // Details
    .vested-award-details-details {

      // Header
      > div.header {
        margin-bottom: 11px;
        display: flex;
        align-items: center;
        height: auto;
      }

      // Content
      > div.content {
        > div {
          > h3 {
            margin: 0;
            padding: 0;
          }
        }

        .gap15 {
          padding: 15px 0;
        }

        .row {
          margin: 0 0 7px;

          > .col-50 {
            width: 50%;
            display: inline-block;

            &:nth-child(2) {
              margin-top: -5px;
            }

            h3 {
              margin-bottom: 2px;
            }

            p {
              margin: 0;
              line-height: normal;
            }

            > div.total {
              border-left: 5px solid #00B550;
              background-color: #e6f7ed;
              border-left: 5px solid #00B550;
              background-color: #e6f7ed;
              padding: 5px 10px;
              font-family: Lato-Regular;
              text-align: right;

              > h3 {
                text-transform: uppercase;
                font-size: 12px;
                color: #666666;
              }
            }
          }
        }
      }
    }
  }

  > div.net-details-section {
    padding: 10px 20px;
    background-color: #e6f7ed;

    .row {
      > span:first-child {
        text-transform: uppercase;
        font-family: Lato-Regular;
        font-size: 12px;
        color: #666666;
        line-height: 40px;
      }

      > span:last-child {
        font-family: Lato-Regular;
        font-size: 34px;
        color: #333333;
        float: right;
      }
    }
  }

  // Notifications
  .notification {
    margin: 0px;
    display: flex;
    align-items: flex-start;

    // Desktop version.
    @media (min-width: 768px) {
      padding: 7px 20px 7px 20px;
    }

    // Mobile version.
    @media (max-width: 768px) {
      padding: 7px 15px 7px 15px;
    }

    > img {
      width: 17px;
      height: 17px;
      margin-top: 3px;
      margin-right: 9px;
    }

    > div {
      flex: 1;

      > span {
        // Desktop version.
        @media (min-width: 768px) {
          display:inline-block;
        }

        // Mobile version.
        @media (max-width: 768px) {
          display:block;
        }
      }

      > a {
        font-family: Lato-Regular;
        font-size: 14px;
        color: #1D71BB;
        line-height: 22px;
        text-decoration: none;

        // Desktop version.
        @media (min-width: 768px) {
        //  display:inline-block;
          //margin-left: auto;
          float: right;
        }

        // Mobile version.
        @media (max-width: 768px) {
          display:block;
        }
      }
    }
  }

  // Thunder Notification
  .withholding-notification {
    border-top: 1px solid #DB3766;
  }

  // Info Notification
  .fractional-notification {
    border-top: 1px solid #00B550;
  }
`

const Footer = styled.div`
  // Desktop version.
  @media (min-width: 768px) {
    padding: 15px 20px;
  }

  // Mobile version.
  @media (max-width: 768px) {
    padding: 10px 15px 20px 15px;
  }

  > div {
    display: table;
    margin: auto;
    margin-top: 3px;
    margin-bottom: 12px;

    > div {
      display: table-row;

      > span {
        display: table-cell;
        vertical-align: middle;
      }

      > span.qty {
        font-family: Lato-Light;
        font-size: 34px;
        color: #00B550;
        text-align: left;
        line-height: 32px;
      }

      > span.label {
        font-family: Lato-Regular;
        font-size: 12px;
        font-weight: normal;
        color: #666666;
        text-align: left;
        line-height: 15px;
        padding-left: 5px;
      }
    }
  }

  > button {
    height: 43px;
    width: 100%;
  }
`


export class VestedAwardDetailsDialog extends Component {

  buttonClickHandler = (callback) => {

    this.props.actions.maintenance.checkMaintenaceStatus().then(isLive => {
      if(isLive) {
        this.props.actions.employee.getDetailedTaxDocument('DETAIL_TAX_PDF',this.props.employee.id, null, null, null, [this.props.transaction.id])
        this.props.onCloseDialog()
      } else {
        history.push("/maintenance", {})
      }
    })
  }

  render() {
    if(this.props.visible) {
      const currency_format = new Intl.NumberFormat(this.props.locale, { style: 'currency', currency: 'USD',minimumFractionDigits: 2, maximumFractionDigits: 2 })
      const currency_format_4 = new Intl.NumberFormat(this.props.locale, { style: 'currency', currency: 'USD',minimumFractionDigits: 4, maximumFractionDigits: 4 })
      const { t } = this.props;
      const { award, transaction, employee } = this.props;
      const brokerUrl = EmployeeService.getEmployeeBrokerUrl(employee)
      const title = t('VestedAwardDetailsDialog.Title', { vest_date: Moment(transaction.transaction_date).format('ll') })
      const awardedDate = t('VestedAwardDetailsDialog.AwardedOn', { awarded_date: Moment(award.awarded_date).format('ll') })
      const acceptedDate = award.acceptance_date ? t('VestedAwardDetailsDialog.AcceptedOn', { accepted_date: Moment(award.acceptance_date).format('ll') }) : t('VestedAwardDetailsDialog.NotAccepted')
      const override_tax_rate = null

      const isRSU = EmployeeService.isRSU(award)
      const isOption = EmployeeService.isOption(award)

      const total_tax_rate = new Intl.NumberFormat(this.props.locale, {style: 'percent',minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(transaction.total_taxes_percent)
      const total_strike_price = currency_format.format(award.strike_price * transaction.shares_transacted)

      const gross_proceeds = currency_format.format(transaction.shares_transacted * transaction.fmv)
      const total_fmv = currency_format_4.format(transaction.fmv)

      const brokerLabels = [t('VestingSummary.TaxBrokerLabel'), t('VestingSummary.NetBrokerLabel')]

      return (
        <VestedAwardDetails
          title={title}
          visible={this.props.visible}
          onCloseDialog={this.props.onCloseDialog}
          width={380}
          className="transaction-summary-dialog"
          contentClassName="vested-award-details-content"
          footerClassName="vested-award-details-footer"
          autoSize={true}
        >
          <Content>
            {/* Transaction Summary */}
            <div className="award-info-section">
              {/* Award Info */}
              <div>
                <h3>{t('VestedAwardDetailsDialog.AwardInfo')}</h3>
                <span className='value'>{`${award.amazon_award_name} | ${award.amazon_award_id} `}</span>
                <span className='award-date'>{awardedDate} ({acceptedDate})</span>
              </div>
            </div>
            <div className="vest-details-section">
              {/* Vest Details */}
              <div className='vested-award-details-details vest-details-section'>

                <div className="header">
                  <h3>{isRSU ? t('VestedAwardDetailsDialog.VestDetails') :t('VestedAwardDetailsDialog.ExerciseDetails') }</h3>
                </div>

                <div className="content">
                  <div className="row">
                    <div className="col-50">
                      <h3>{isRSU ? t('VestedAwardDetailsDialog.RSUsVested') : t('VestedAwardDetailsDialog.OptionsExercised')  }</h3>
                      <p className='value'>{transaction.shares_transacted}</p>
                    </div>
                    { isOption &&
                      <div className="col-50">
                        <div className="total">
                          <h3>{t('VestedAwardDetailsDialog.GrossProceeds')}</h3>
                          <p className='value'>{gross_proceeds}</p>
                        </div>
                      </div>
                    }
                  </div>
                  <div className="row">
                    <div className="col-50">
                      <h3>{t('VestedAwardDetailsDialog.FairMarketValue')}</h3>
                      <p className='value'>{total_fmv}</p>
                    </div>
                    <div className="col-50">
                      <div className="total">
                        <h3>{t('VestedAwardDetailsDialog.TaxableIncome')}</h3>
                        <p className='value'>{currency_format.format(transaction.taxable_income)}</p>
                      </div>
                    </div>
                  </div>

                  { isOption &&
                    <div className="row gap15">
                      <div className="col-50">
                        <h3>{t('VestedAwardDetailsDialog.OptionPrice')}</h3>
                        <p className="value">{currency_format_4.format(award.strike_price)}</p>
                      </div>
                      <div className="col-50">
                        <div className="total">
                          <h3>{t('VestedAwardDetailsDialog.OptionCosts')}</h3>
                          <p className="value">{total_strike_price}</p>
                        </div>
                      </div>
                    </div>
                  }

                  <div className="row">
                    <div className="col-50">
                      <div className="broker-name">
                        <h3>{t('VestedAwardDetailsDialog.BrokersLabel')}</h3>
                        <p className='value'>
                          {this.props.brokers && this.props.brokers.map((broker, i) =>
                              <span key={i}>{broker}&nbsp;{this.props.brokers.length > 1 && brokerLabels[i]}</span>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tax-details-section">
              {/* Tax Details */}
              <div className='vested-award-details-details tax-details-section'>
                <div className="header">
                  <h3>{t('VestedAwardDetailsDialog.TaxDetails')}</h3>
                  {/* Federal Tax */}
                  {override_tax_rate &&
                    <span className='federal-tax'>{t('VestedAwardDetailsDialog.FederalTax', { federal_tax: new Intl.NumberFormat(this.props.locale, {style: 'percent',minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(override_tax_rate) })}</span>
                  }
                </div>

                <div className="content">
                  <div className="row gap15">
                    <div className="col-50">
                      <h3>{t('VestedAwardDetailsDialog.TotalTaxRate')}</h3>
                      <p className='value'>{total_tax_rate}</p>
                    </div>
                    <div className="col-50">
                    { isRSU &&
                      <div className="total">
                          <h3>{t('VestedAwardDetailsDialog.TaxElection')}</h3>
                          <p className='value'>{t(`TaxTreatment.${transaction.tax_election.code}`)}</p>
                      </div>
                      }
                      { isOption &&
                        <div className="total">
                          <h3>{t('VestedAwardDetailsDialog.OptionTaxElection')}</h3>
                          <p className='value'>{transaction.transaction_type_name}</p>
                        </div>
                      }
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-50">
                      <h3>{isRSU ? t('VestedAwardDetailsDialog.RSUsSold') : t('VestedAwardDetailsDialog.OptionsSold')}</h3>
                      <p className='value'>{transaction.shares_sold === -1 ? '-' : transaction.shares_sold }</p>
                    </div>
                    <div className="col-50">
                      <div className="total">
                        <h3>{t('VestedAwardDetailsDialog.TotalTaxes')}</h3>
                        <p className='value'>{currency_format.format(transaction.total_tax)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Withholding notification */}
            {transaction.amount_subject_to_withholding > 0 &&
              <div className='notification withholding-notification'>
                <img alt="" src={ThunderIcon} />
                <div>
                  <span className='value'>{t('VestedAwardDetailsDialog.BackupWitholding', { backup_witholding: currency_format.format(transaction.amount_subject_to_withholding) })}</span>
                  <a href={brokerUrl} target='_blank'>{t('VestedAwardDetailsDialog.CertifyAtBroker')}</a>
                </div>
              </div>
            }

            {/* Fractional cash refund notification */}
            {transaction.fractional_cash_refund > 0 &&
              <div className='notification fractional-notification'>
                <img alt="" src={InfoIcon} />
                <div>
                  <span className='value'>{t('VestedAwardDetailsDialog.FractionalCash', { fractional_cash: currency_format.format(transaction.fractional_cash_refund)})}</span>
                </div>
              </div>
            }

            <div className="net-details-section">
              {isRSU && transaction.net_shares > 0 &&
                <div className="row">
                  <span>{t('VestedAwardDetailsDialog.SharesDeposited')}</span>
                  <span>{transaction.net_shares}</span>
                </div>
              }

              {isOption && (transaction.net_proceeds > 0 || transaction.net_shares > 0) &&
                <div>
                  {transaction.net_proceeds > 0 &&
                    <div className="row">
                      <span>{t('VestedAwardDetailsDialog.NetProceeds')}</span>
                      <span>{currency_format.format(transaction.net_proceeds)}</span>
                    </div>
                  }
                  {transaction.net_shares > 0 &&
                    <div className="row">
                        <span>{t('VestedAwardDetailsDialog.OptionsDeposited')}</span>
                        <span>{transaction.net_shares}</span>
                    </div>
                  }
                </div>
              }
            </div>
          
          </Content>
          <Footer>
            <button className='primary-button vested-award-details-view-as-pdf' onClick={this.buttonClickHandler}>{t('VestedAwardDetailsDialog.ViewAsPDF')}</button>
          </Footer>
        </VestedAwardDetails>
      )
    }

    return null

  }
}
const mapState = state => ({
  employee: state.employee
})

const mapDispatchToProps = dispatch => ({
  actions: {
    employee: bindActionCreators(employeeActions, dispatch),
    maintenance: bindActionCreators(maintenanceActions, dispatch),
  }
})

export default connect(mapState, mapDispatchToProps)((withTranslation('translations')(VestedAwardDetailsDialog)))


